<template>
  <modal
    ref="integrationModal"
    template="neutral"
    ref-name="integrationModal"
    :icon-enabled="false"
    :close-button-enabled="true"
    class="integration-modal"
  >
    <button
      class="close-button btn-transparent"
      @click="closeIntegrationModal"
    >
      <md-icon>clear</md-icon>
    </button>
    <div class="integration-modal__tabs">
      <h3
        :class="{ active: activeTab === 'params' }"
        @click="setTab('params')"
      >
        Parâmetros do exame
      </h3>
      <h3
        :class="{ active: activeTab === 'result' }"
        @click="setTab('result')"
      >
        Linhas de Resultado
      </h3>
      <!-- <h3 @click="setTab('methods')" :class="{ active: activeTab === 'methods' }">Metodologia</h3> -->
    </div>
    <div
      v-if="!loading"
      class="integration-modal__content"
    >
      <template v-if="activeTab === 'params'">
        <div
          v-if="paramsList.mnemonic && paramsList.materials && paramsList.lastChange"
          class="integration-modal__data"
        >
          <div class="integration-modal__data--top">
            <div class="integration-modal__values integration-modal__values--full">
              <h5>Mnemônico e descrição do exame</h5>
              <div class="value">
                <span>
                  {{ paramsList.mnemonic + ' - ' + paramsList.name }}
                </span>
                <ButtonCopy
                  v-if="paramsList.mnemonic + ' - ' + paramsList.name"
                  :text-to-copy="paramsList.mnemonic + ' - ' + paramsList.name"
                />
              </div>
            </div>
            <div class="integration-modal__values integration-modal__values--half">
              <h5>Data da última alteração</h5>
              <div class="value">
                <span>
                  {{ lastChange }}
                </span>
                <ButtonCopy
                  v-if="lastChange"
                  :text-to-copy="lastChange"
                />
              </div>
            </div>
            <template v-for="(material, index) in paramsList.materials">
              <div
                v-if="material.materialDefault"
                class="integration-modal__values integration-modal__values--half"
              >
                <h5>Material padrão</h5>
                <div class="value">
                  <span>
                    {{ material.code + ' - ' + material.name }}
                  </span>
                  <ButtonCopy
                    v-if="material.name"
                    :text-to-copy="material.code + ' - ' + material.name"
                  />
                </div>
              </div>
            </template>
          </div>
          <div class="integration-modal__values integration-modal__box-materials">
            <h5>Materiais possíveis</h5>
            <div class="integration-modal__values integration-modal__values--full">
              <div
                v-for="(material, index) in paramsList.materials"
                class="value"
              >
                <span>
                  {{ material.code + ' - ' + material.name }}
                </span>
                <ButtonCopy
                  v-if="material.name"
                  position="left"
                  :text-to-copy="material.code + ' - ' + material.name"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="integration-modal__error-msg"
        >
          <img
            src="/static/images/icon-empty-cart.svg"
            alt="Esse exame não possui parâmetros do exame"
          />
          <p>
            Esse exame não possui
            <br />
            parâmetros do exame
          </p>
        </div>
      </template>
      <template v-if="activeTab === 'result'">
        <div
          v-if="paramsList.criticisms"
          class="integration-modal__table"
        >
          <div
            class="integration-modal__table-content integration-modal__table-content--fixed"
          >
            <h5 class="code">Código</h5>
            <h5 class="name">Nome</h5>
            <h5 class="line">Linha</h5>
            <h5 class="unit">Unidade</h5>
          </div>
          <div class="integration-modal__table-wrapper">
            <div
              v-for="(param, index) in paramsList.criticisms"
              :key="`param-criticism-${index}-${param.idCriticism || index}`"
              class="integration-modal__table-content integration-modal__table-content--values"
            >
              <div class="code">
                <span>
                  {{ param.idCriticism }}
                </span>
                <ButtonCopy
                  v-if="param.idCriticism"
                  :text-to-copy="param.idCriticism"
                />
              </div>
              <div class="name">
                <span>
                  {{ param.name }}
                </span>
                <ButtonCopy
                  v-if="param.name"
                  :text-to-copy="param.name"
                />
              </div>
              <div class="line">
                <span>
                  {{ param.position }}
                </span>
                <ButtonCopy
                  v-if="param.position"
                  :text-to-copy="param.position"
                />
              </div>
              <div class="unit">
                <span>
                  {{ param.unit }}
                </span>
                <ButtonCopy
                  v-if="param.unit"
                  :text-to-copy="param.unit"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="integration-modal__error-msg"
        >
          <img
            src="/static/images/icon-empty-cart.svg"
            alt="Esse exame não possui linhas de resultado"
          />
          <p>
            Esse exame não possui
            <br />
            linhas de resultado
          </p>
        </div>
      </template>
      <template v-if="activeTab === 'methods'">
        <div
          v-if="paramsList.examMethod"
          class="integration-modal__data integration-modal__data--methods"
        >
          <div class="integration-modal__values integration-modal__values--half">
            <h5>Código da metodologia</h5>
            <div class="value">
              <span>
                {{ paramsList.examCodeMethod }}
              </span>
              <ButtonCopy
                v-if="paramsList.examCodeMethod"
                :text-to-copy="paramsList.examCodeMethod"
              />
            </div>
          </div>
          <div class="integration-modal__values integration-modal__values--half">
            <h5>Metodologia</h5>
            <div class="value">
              <span>
                {{ paramsList.examMethod }}
              </span>
              <ButtonCopy
                v-if="paramsList.examMethod"
                :text-to-copy="paramsList.examMethod"
              />
            </div>
          </div>
        </div>
        <div
          v-else
          class="integration-modal__error-msg"
        >
          <img
            src="/static/images/icon-empty-cart.svg"
            alt="Esse exame não possui metodologia"
          />
          <p>
            Esse exame não possui
            <br />
            metodologia
          </p>
        </div>
      </template>
    </div>

    <!-- <button class="integration-modal__btn-export" @click="downloadExcel" v-if="!loading && paramsList">
      <svg-loader class="icon-download-modal" src="/static/images/site/icon-download.svg" />
      Exportar em Excel
    </button> -->
    <Spinner v-else />
  </modal>
</template>
<script>
import Spinner from '@/components/common/Spinner'
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'
import examGuideService from '@/api/examGuide'
import Moment from 'moment'

export default {
  name: 'IntegrationModalParams',
  components: {
    Spinner,
    ButtonCopy,
  },
  data: () => ({
    paramsList: [],
    msgError: false,
    activeTab: 'params',
    loading: false,
  }),
  computed: {
    mnemonic() {
      return this.$route.query.mnemonic
    },
    lastChange() {
      return Moment(this.paramsList.lastChange).format('DD/MM/YYYY')
    },
  },
  methods: {
    openIntegrationModal() {
      document.documentElement.style.overflow = 'hidden'
      this.loading = true

      examGuideService
        .getIntegrationParams(this.mnemonic)
        .then(response => {
          this.loading = false
          this.paramsList = response.data
        })
        .catch(err => {
          this.loading = false
          this.msgError = err.response.data.message
        })
      this.$refs.integrationModal.open()
    },
    closeIntegrationModal() {
      document.documentElement.style.overflow = ''
      this.$refs.integrationModal.close()
      this.msgError = false
      this.paramsList = []
      this.activeTab = 'params'
    },
    downloadExcel() {
      window.open(
        process.env.EXAM_GUIDE_URL +
          'exams/integration/parameter/mnemonic/' +
          this.mnemonic +
          '/xlsx'
      )
    },
    setTab(tab) {
      this.activeTab = tab
    },
  },
}
</script>
<style lang="scss">
.integration-modal {
  font-family: 'Exo 2', sans-serif !important;

  .md-dialog {
    min-width: 800px;
    width: 90%;
    max-width: 1000px;
    height: 620px;
    min-height: 620px;
  }

  .md-dialog-title {
    display: none;
  }

  .md-dialog-content {
    padding: 0;
    display: flex;
    flex-flow: column;

    > div:first-child {
      flex: 1;
      display: flex;
      flex-flow: column;
      overflow: hidden;
    }
  }

  .close-button {
    z-index: 90;
    top: 15px;
    right: 24px;
  }

  .loader {
    width: 80px;
    height: 80px;
    margin: 50px auto 20px;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-flow: column;
    overflow-y: hidden;
  }

  &__table,
  &__data {
    margin-top: 24px;
    padding: 0 80px 50px;
    flex: 1;
    align-content: flex-start;
  }

  &__table {
    padding: 0 80px 0px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;

    &-wrapper {
      overflow-y: scroll;
      flex: 1 1 100%;
    }
  }

  &__data {
    display: flex;
    margin-top: 12px;

    &:not(.integration-modal__data--methods) {
      height: 100%;
      padding-bottom: 0;
      flex-direction: column;
    }

    &--top {
      display: flex;
      flex-wrap: wrap;
      margin-top: 12px;
    }
  }

  &__values {
    margin-top: -4px;
    flex-shrink: 1;
    width: 100%;

    &--full {
      flex: 1 1 100%;
    }

    &--half {
      flex: 1 1 50%;
      max-width: 50%;
    }

    h5 {
      color: #7f1a54;
      font-weight: 400;
      font-size: 12px;
      margin: 20px 4px 0;
    }

    .value {
      border-radius: 3px;
      background-color: #f5f5f5;
      padding: 0 8px;
      height: 40px;
      margin: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      span {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: width ease 0.3s;
      }

      &:hover {
        background-color: rgba(127, 26, 84, 0.08);
        overflow: inherit;

        span {
          width: calc(100% - 36px);
        }

        .btn-copy {
          opacity: 1;
        }
      }
    }
  }

  &__table-content {
    display: flex;
    margin: 0 -4px;

    &--values {
      margin-top: -4px;
      flex-shrink: 1;
      width: 100%;

      .name {
        font-weight: 600;
      }
    }

    & > h5 {
      color: #7f1a54;
      font-weight: 400;
      font-size: 12px;
      margin: 4px;
    }

    & > div {
      border-radius: 3px;
      background-color: #f5f5f5;
      padding: 0 8px;
      height: 40px;
      margin: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      span {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: width ease 0.3s;
      }

      &:hover {
        background-color: rgba(127, 26, 84, 0.08);
        overflow: inherit;

        span {
          width: calc(100% - 36px);
        }

        .btn-copy {
          opacity: 1;
        }
      }
    }

    .code {
      min-width: 90px;
    }

    .name {
      flex-grow: 1;
      min-width: 500px;
    }

    .unit {
      width: 100px;
    }

    .line {
      width: 60px;
    }
  }

  &__tabs {
    display: flex;
    justify-content: space-between;
    padding: 50px 80px 0;
    background: #f4f4f4;

    h3 {
      font-size: 16px;
      flex: 1 1;
      flex-grow: 1 !important;
      text-align: center;
      color: #7a7a7a;
      font-weight: 400;
      padding-bottom: 8px;
      cursor: pointer;

      &.active {
        font-weight: 600;
        color: #7f1a54;
        border-bottom: 2px solid #7f1a54;
      }
    }
  }

  &__btn-export {
    background-color: transparent;
    border: 2px solid #7f1a54;
    color: #7f1a54;
    text-transform: uppercase;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 100%;
    margin-top: 15px;
    font-family: 'Exo 2', sans-serif !important;
    font-size: 12px;
    padding: 0 16px;
    font-weight: 600;
    transition: all 0.4s ease-in-out;
    max-width: 180px;
    margin: 24px auto 32px;

    &:hover {
      background-color: #7f1a54;
      color: #fff;

      .md-icon {
        path {
          fill: #fff;
        }
      }
    }

    .md-icon {
      margin: 0 2px 0 0;

      svg {
        width: 20px;
      }

      path {
        transition: all 0.4s ease-in-out;
      }
    }
  }

  &__box-materials {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .integration-modal__values {
      margin-top: 0;
      overflow-y: auto;
      padding-bottom: 15px;

      .value {
        overflow: hidden !important;
      }
    }
  }

  &__error-msg {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px;
    flex: 1;

    img {
      margin-bottom: 25px;
    }

    p {
      font-size: 23px;
      color: #818181;
      font-weight: 400;
      line-height: 27.65px;
      text-align: center;
    }
  }
}
</style>
